/** Recognize only a final conventional sign-off paragraph, retaining its spacing. */
export const EMAIL_LETTER_CLOSING_PATTERN =
  /(?:^|\r?\n\r?\n)((?:Thank you|Thanks|Best regards|Kind regards|Regards|Sincerely|Best|Cheers|Warm regards|Yours sincerely|Yours faithfully),[^\r\n]*(?:\r?\n[^\r\n]+)*\s*)$/i;
